import DonutChartHook from './donut-chart'
import GaugeChartHook from './gauge-chart'
import StackedColumnChartHook from './stacked-column-chart'
import LineChartHook from './line-chart'
import ColumnChartHook from './column-chart'
import BarChartHook from './bar-chart'

export default {
  DonutChartHook,
  GaugeChartHook,
  StackedColumnChartHook,
  LineChartHook,
  ColumnChartHook,
  BarChartHook,
}
